import {
	FEATURED_STREAMS_UPDATE,
	RETRIEVE_EXTERNAL_STREAMS_BEGIN,
	RETRIEVE_EXTERNAL_STREAMS_FAIL,
	RETRIEVE_EXTERNAL_STREAMS_SUCCESS,
} from '../actions/featuredStreams';


const initialState = {
	featuredStreams: [],
	retrievingExternalStreams: false,
	externalStreamList: [],
	activeFeaturedStreamPlayers: {},
};

export default (state = initialState, action) => {
	switch(action.type) {
		case RETRIEVE_EXTERNAL_STREAMS_SUCCESS:
			return {
				...state,
				externalStreamList: action.payload,
				retrievingExternalStreams: false
			};
		case RETRIEVE_EXTERNAL_STREAMS_BEGIN:
			return {
				...state,
				retrievingExternalStreams: true
			};
		case RETRIEVE_EXTERNAL_STREAMS_FAIL:
			return {
				...state,
				retrievingExternalStreams: false
			};
		case FEATURED_STREAMS_UPDATE: {
			const streams = Array.from(action.payload);
			const activeStreamPlayers = {};
			for(let stream of streams) {
				if(!stream.player) {
					continue;
				}
				activeStreamPlayers[stream.player.id] = stream.player;
			}
			return {
				...state,
				featuredStreams: Array.from(action.payload),
				activeFeaturedStreamPlayers: activeStreamPlayers,
			};
		}
		default:
			return state;
	}
}